import React from 'react';

const formatMoney = (amount, currency = 'LKR') => {
  const value = Number(amount) || 0;
  try {
    return new Intl.NumberFormat('en-LK', {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(value);
  } catch (_) {
    return `${currency} ${value.toLocaleString()}`;
  }
};

/**
 * Shows stage-band membership due/waived lines from a pricing quote or payment snapshot.
 */
const MembershipFeeBandsSummary = ({
  bands = [],
  membershipFeeAmount = null,
  currency = 'LKR',
  compact = false
}) => {
  const lines = Array.isArray(bands) ? bands.filter(Boolean) : [];
  if (lines.length === 0) {
    if (membershipFeeAmount == null) return null;
    return (
      <div className={compact ? 'text-xs text-gray-600' : 'text-sm text-gray-700'}>
        Membership fee: {formatMoney(membershipFeeAmount, currency)}
      </div>
    );
  }

  return (
    <div className={compact ? 'space-y-1' : 'space-y-1.5'}>
      {lines.map((band) => {
        const status = String(band.status || '').toLowerCase();
        const payable = Number(band.payableAmount) || 0;
        const catalog = Number(band.catalogAmount) || 0;
        const label = band.label || `Stage ${band.stageFrom}–${band.stageTo} Membership`;
        let statusNote = '';
        if (status === 'waived_already_paid') {
          const appNo = band.satisfiedBy?.applicationNumber;
          statusNote = appNo ? `Already paid (${appNo})` : 'Already paid';
        } else if (status === 'included') {
          statusNote = 'Included in course fee';
        } else if (payable > 0) {
          statusNote = 'Due';
        }

        return (
          <div
            key={band.key || `${band.stageFrom}-${band.stageTo}`}
            className={`flex items-start justify-between gap-3 ${compact ? 'text-xs' : 'text-sm'}`}
          >
            <div className="min-w-0">
              <div className="font-medium text-gray-800 truncate">{label}</div>
              {statusNote ? (
                <div className={`text-xs ${status === 'waived_already_paid' || status === 'included' ? 'text-emerald-700' : 'text-gray-500'}`}>
                  {statusNote}
                </div>
              ) : null}
            </div>
            <div className="text-right whitespace-nowrap text-gray-800">
              {payable > 0 ? (
                formatMoney(payable, currency)
              ) : (
                <span className={status === 'included' || status === 'waived_already_paid' ? 'text-gray-600' : 'text-gray-500'}>
                  {formatMoney(
                    (status === 'included' || status === 'waived_already_paid') && catalog > 0
                      ? catalog
                      : 0,
                    currency
                  )}
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MembershipFeeBandsSummary;
